// SidebarLink.tsx or SidebarLink.jsx
import { NavLink } from "react-router-dom";

const NavLinker = ({
  to,
  end = false,
  children,
  activeClassName = "flex flex-row bg-blue-500 bg-opacity-08 p-2 rounded-md text-white gap-2 items-center",
  inactiveClassName = "flex flex-row hover:bg-[#629FF4] hover:text-white rounded-md p-2 gap-2 items-center",
}) => {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        isActive ? activeClassName : inactiveClassName
      }
    >
      {children}
    </NavLink>
  );
};

export default NavLinker;
